<app-header-modal [color]="'secondary-2'" title="{{title}}">
  <div icon *ngIf="showPalletHistory">
    <i class="uil uil-arrow-left" (click)="goToOrderDetails()"></i>
  </div>
  <i class="uil uil-times" (click)="close()" status></i>
</app-header-modal>

<div class="content">
  <mat-tab-group mat-align-tabs="center" *ngIf="!showPalletHistory"
    [selectedIndex]="selected.value"
    (selectedIndexChange)="onSelectedIndexChange($event)">
    <mat-tab label="Detalhes de Ordem de Venda">
      <div class="wrapper">
        <div class="up-modal">
          <div class="left">
            <div class="column">
              <app-info-oc-or-nfe label="Nº" [value]="sellOrder?.no ? sellOrder.no : '---' "></app-info-oc-or-nfe>
              <app-info-oc-or-nfe label="Razão Social" [value]="'---'" ></app-info-oc-or-nfe>
              <app-info-oc-or-nfe label="Endereço" [value]="'---'"></app-info-oc-or-nfe>
            </div>
            <div class="column two">
              <app-info-oc-or-nfe label="Data/Hora de Entrada" [value]="timestampToDate(sellOrder?.date)"></app-info-oc-or-nfe>
              <app-info-oc-or-nfe label="Data/Hora de Saída" [value]="timestampToDate(sellOrder?.outOrderEventHistoryDispatchedAt)"></app-info-oc-or-nfe>
              <app-info-oc-or-nfe label="CPF/CNPJ Fornecedor" [value]="'---' "></app-info-oc-or-nfe>
            </div>
          </div>
          <div class="right">
            <app-provider-contact [provider]="{ name: '---', phone: '---', email: '---' }"></app-provider-contact>
          </div>
        </div>
        <div class="table">
          <app-material-generic-table
            [dataSource]="manifestTableData"
            [columnsDefinition]="manifestColumnsDefinition"
            [displayedColumns]="manifestDisplayedColumns"
            [emptyDataMessage]="'Não existem produtos.'">
          </app-material-generic-table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Detalhes da Expedição">
      <app-sell-order-expedition-details
        [sellOrder]="sellOrder"
        (crateClick)="goToPalletHistory($event)">
      </app-sell-order-expedition-details>
    </mat-tab>

    <mat-tab label="Histórico">
      <app-order-history [orderId]="sellOrder?.id"></app-order-history>
    </mat-tab>

    <mat-tab label="Comentários">
      <app-in-details-comments
        [itemDetails]="{ comments: comments }"
        (submitEvent)="submitComment($event)" (deleteEvent)="deleteComment($event)">
      </app-in-details-comments>
    </mat-tab>
  </mat-tab-group>
  <div *ngIf="showPalletHistory" class="history-wrapper">
    <app-movement-details [crateId]="crateId"></app-movement-details>
  </div>
</div>
